import data from "data/airdrop";
import AboutStyleWrapper from "gamfi/sections/About/v1/About.style";
import LiveProject from "./LiveProject";
import Tutorial from "./Tutorial";

const About = () => {
  return (
    <AboutStyleWrapper>
      <LiveProject />
      <Tutorial
        title="HOW TO PARTICIPATE"
        subtitle="3 EASY STEPS"
        isCenter={false}
        steps={data}
      />
    </AboutStyleWrapper>
  );
};

export default About;
